if (typeof Clock !== 'function') {
    function Clock (countdown, callback) {
        countdown = countdown < new Date()? new Date() : countdown;
        countdown = countdown ? countdown : false
        callback = callback || function () {}
        var updateFn = countdown ? getTimeRemaining : getTime

        this.el = document.createElement('div')
        this.el.className = 'flip-clock'

        var trackers = {},
            t = updateFn(countdown),
            key,
            timeinterval

        for (key in t) {
            if (key === 'Total') {
                continue
            } else {
                trackers[key] = new CountdownTracker(key, t[key], false)
            }
            this.el.appendChild(trackers[key].el)
        }

        function CountdownTracker(label, value) {
            var el = document.createElement('span')
        
            el.className = 'flip-clock__piece'
            el.innerHTML =
                '<span class="flip-clock__card"><b class="card__time"></b></span>' +
                '<span class="flip-clock__slot">' +
                label +
                '</span>'
        
            this.el = el
            var card = el.querySelector('.card__time')
        
            this.update = function (val) {
                if (val !== this.currentValue) {
        
                    val = val.toString();
                    if(val.length === 1){
                        val = '0' + val;
                    }
                    this.currentValue = val
                    card.innerText = this.currentValue
        
                    this.el.classList.remove('flip')
                    void this.el.offsetWidth
                    this.el.classList.add('flip')
                }
            }
        
            this.update(value)
        }

        var i = 0
        function updateClock() {
            timeinterval = requestAnimationFrame(updateClock)
    
            if (i++ % 10) {
                return
            }
    
            var t = updateFn(countdown)
            if (t.Total < 0) {
                cancelAnimationFrame(timeinterval)
                for (key in trackers) {
                    trackers[key].update(0)
                }
                callback()
                return
            }
    
            for (key in trackers) {
                trackers[key].update(t[key])
            }
        }
        setTimeout(updateClock, 500)

        function getTime(){
            var t = new Date()
            return {
                Total: t,
                Hours: t.getHours() % 12,
                Minutes: t.getMinutes(),
                Seconds: t.getSeconds(),
            }
        }

        function getTimeRemaining(endtime){
            var t = endtime - new Date()
            current_location = window.location.href
        
            return {
                Total: t,
                Days: Math.floor(t / (1000 * 60 * 60 * 24)),
                Hours: Math.floor((t / (1000 * 60 * 60)) % 24),
                Minutes: Math.floor((t / 1000 / 60) % 60),
                Seconds: Math.floor((t / 1000) % 60),
            }
        }
    }
}

if(!customElements.get('custom-featured-product')){
    class CustomFeaturedProduct extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.init();
        }

        init(){
            // countdown
            this.countdown = this.querySelector('.countdown-grid__timer');
            if(this.countdown){
                var timerDate = this.querySelector('.countdown-grid__timer').dataset.date;

                if(this.isValidDateFormat(timerDate)){
                    var deadline = new Date(timerDate);
                    var counter = new Clock(deadline, function(){})
                    this.querySelector('.countdown-grid__timer').innerHTML = '';
                    this.querySelector('.countdown-grid__timer').append(counter.el)
                }
            }

            // Product media
            this.productMedia = this.querySelector('product-media');
            this.productMediaImages = this.querySelectorAll('product-media-image');
            this.swiperContainer = (this.productMedia)? this.productMedia.querySelector('.swiper-container') : null;
            this.paginationSwiperContainer = this.productMedia?.querySelector('.pagination-swiper-container');
            this.productModels = this.querySelectorAll('product-model');

            document.addEventListener('DOMContentLoaded', () => {
                if(!this.querySelector('variant-wrapper') && this.productMedia){
                    this.productMedia.setAttribute('data-hidden', 'false');
                }
            }, false);
            this.productMedia = this.querySelector('.featured-product__image'); // video media
            if(this.swiperContainer){
                if(parseInt(this.swiperContainer.dataset.swiperSize) > 1){
                    this.initSwiper();
                }
            }
            if(this.paginationSwiperContainer) this.initPaginationSwiper();

            if(this.productMedia){
                document.addEventListener('scroll', this.scrollMedia.bind(this), false);
                document.addEventListener('resize', this.scrollMedia.bind(this), false);
            }

            // Submit the form
            this.btnCart = this.querySelector('.btn-cart');
            this.buyButtons = this.querySelector('.product-buy-buttons');
            this.form = this.querySelector('#product-form');
            this.cart = document.querySelector('custom-cart-popup');

            this.form.addEventListener('submit', this.submitToCart.bind(this));
        }


        scrollMedia(){
            if(!this.productMedia) return;

            this.productMedia.querySelectorAll('.media-wrapper').forEach(item => {
                var visible = this.isInViewport(item);

                if(visible && item.getAttribute('data-active') == 'false' && item.classList.contains('swiper-slide-active')){
                    this.updateMedia(item);
                }
            });
        }

        
        initPaginationSwiper(){
            if(!this.paginationSwiperContainer) return;

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: false,
                spaceBetween: 10,
                speed: 500,
                centeredSlides: false,
                breakpoints: {
                    0: { slidesPerView: 3 },
                    576: {
                        slidesPerView: 5
                    }
                },
                observer: true,
                observeSlideChildren: true,
                watchOverflow: true,
                on: {
                    init: () => {
                        this.isNextSlide(this.paginationSwiper);
                    },
                    resize: () => {
                        this.isNextSlide(this.paginationSwiper);
                    }
                }
            }

            swiperSettings.navigation = {
                nextEl: this.paginationSwiperContainer.querySelector('.swiper-button-next'),
                prevEl: this.paginationSwiperContainer.querySelector('.swiper-button-prev')
            }

            this.paginationSwiper = new Swiper(this.paginationSwiperContainer, swiperSettings);
            this.paginationSwiper.init();

            this.paginationItems = this.paginationSwiperContainer.querySelectorAll('product-media-pagination-thumbnail');
            this.paginationItems.forEach(item => {
                item.addEventListener('click', e => {
                    const currentIndex = parseInt(item.dataset.index);
                    if(!isNaN(currentIndex)){
                        const activeSlide = this.querySelector(`.media-wrapper[data-media-idx="${currentIndex}"]`);
                        if(activeSlide){
                            const index = activeSlide.getAttribute('data-swiper-slide-index')
                                || Array.from(activeSlide.parentElement.children).indexOf(activeSlide);
                            
                            this.swiper.slideTo(index);
                        }
                    }
                });
            })
        }

        isNextSlide(swiper){
            if(!swiper.isEnd){ // there is next slide
                this.paginationSwiperContainer.style.setProperty('--swiper-max-width', 'calc(100% - 45px)');
            }else{
                this.paginationSwiperContainer.style.setProperty('--swiper-max-width', '100%');
            }
        }

        initSwiper(){
            if(!this.swiperContainer) return;
            var swiperSettings = {
                init: true,
                initialSlide: 0,
                loop: false,
                spaceBetween: 0,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true
            }

            swiperSettings.navigation = {
                nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
            }

            swiperSettings.pagination = {
                el: this.swiperContainer.querySelector('.swiper-pagination')
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.checkPagination();
            this.getVisibleSlides();

            this.swiper.on("slideChange", e => {
                this.stopAllVideo();
                this.closeZoomImages();
                this.closeProductModels();
                this.getVisibleSlides();

                // start media
                var currentSlide = this.swiperContainer.querySelector(`.swiper-slide[data-media-idx="${e.realIndex + 1}"]`);
                var mediaType = currentSlide.dataset.mediaType;
                if(mediaType == 'video'){
                    this.startVideo(currentSlide.querySelector('video'), mediaType);
                }else if(mediaType == 'external_video'){
                    this.startVideo(currentSlide.querySelector('iframe'), mediaType);
                }
            });

            this.swiper.on("resize", () => {
                this.checkPagination();
            })

            this.loadMedia();
        }

        closeZoomImages(){
            this.productMediaImages.forEach(item => {
                item.zoomOut();
            })
        }

        closeProductModels(){
            this.productModels.forEach(item => {
                item.closeProductModel();
            })
        }

        loadMedia(){
            var activeSlide = this.querySelector('.swiper-slide-active');
            
            if(this.dataset.page == 'featured-product'){ // featured product
                var visible = this.isInViewport(activeSlide);
                if(!visible){
                    if(activeSlide) activeSlide.setAttribute('data-active', 'false');
                    return;
                }
            }

            this.updateMedia(activeSlide);
        }

        disableTouchSwipe(){
            if(this.swiper) this.swiper.allowTouchMove = false;
        }

        enableTouchSwipe(){
            if(this.swiper) this.swiper.allowTouchMove = true;
        }

        updateMedia(elem){
            this.stopAllVideo();
            this.closeZoomImages();
            this.closeProductModels();

            this.productMedia.querySelectorAll('.media-wrapper').forEach(item => {
                item.setAttribute('data-active', 'false');
            })

            elem.setAttribute('data-active', 'true');
            
            var mediaType = elem.dataset.mediaType;

            if(mediaType == 'video'){
                this.startVideo(elem.querySelector('video'), mediaType);
            }else if(mediaType == 'external_video'){
                this.startVideo(elem.querySelector('iframe'), mediaType);
            }
        }


        stopAllVideo(){
            // external video
            var externalVideos = this.querySelectorAll('product-media iframe');
            externalVideos.forEach(item => {
                // youtube
                if(item.contentWindow)
                    item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');

                // vimeo
                var vimeoUrl = new URL(item.src);
                if (vimeoUrl.hostname.includes('vimeo.com')) {
                    var vimeoData = {
                        method: 'pause'
                    };
                    item.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                    var seekData = {
                        method: 'setCurrentTime',
                        value: 0
                    };
                    item.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
                }
                
                if(item.closest('.media-wrapper')){
                    const thumbnail = item.closest('.media-wrapper').querySelector('.thumbnail');
                    if(thumbnail){
                        thumbnail.style.opacity = '1';
                        thumbnail.style.transition = 'opacity 0.5s ease-in';
                    }
                }
            });

            // video
            var embedVideos = this.querySelectorAll('product-media video');
            embedVideos.forEach(item => {
                item.pause();
                item.currentTime = 0;
            });
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        submitToCart(e){
            e.preventDefault();

            if(this.btnCart.getAttribute('data-disabled') == 'true') return;
    
            // remove sold out message
            if(this.querySelector('.badge--sold-out')){
               this.querySelector('.price').classList.remove('price--sold-out');
               this.querySelector('.badge--sold-out').remove();
            }

            const formData = new FormData(this.form);

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch('/cart/add', config)
            .then(res => res.json())
            .then(res => {
                this.recipientForm = this.querySelector('recipient-form');
                if(this.recipientForm){
                    this.recipientForm.errorMessage.setAttribute('data-active', 'false');
                    this.recipientForm.errorMessage.querySelector('.form-status').innerHTML = '';
                    this.recipientForm.querySelectorAll('.input-wrapper').forEach(item => {
                        item.setAttribute('data-invalid', 'false');
                    })
                }

                if(res.status){
                    if(res.errors){
                        var errors = Object.keys(res.errors);
                        if(errors.includes('email')){
                            if(this.recipientForm){
                                let error = document.createElement('li');
                                error.innerHTML = `Email ${res.errors.email}`;
                                this.recipientForm.errorMessage.querySelector('.form-status').appendChild(error);

                                this.recipientForm.errorMessage.setAttribute('data-active', 'true');
                                this.recipientForm.querySelector('.input-wrapper[data-error-msg="email"]').setAttribute('data-invalid', 'true');

                                this.recipientForm.errorMessage.focus();
                            }
                            return;
                        }
                    }

                    if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'true');

                    if(res.message.includes('is already sold out.')){ // sold out message
                        if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'true');

                        // add sold out message
                        let soldoutBadge = document.createElement('span');
                        soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                        soldoutBadge.classList.add('badge');
                        soldoutBadge.classList.add('badge--sold-out');

                        this.querySelector('.price').appendChild(soldoutBadge);
                        this.querySelector('.price').classList.add('price--sold-out');
                        this.querySelector('.price').classList.remove('price--on-sale');
                    }

                    if(res.description){
                        if(this.querySelector('#product-form .cart-422-error')){
                            this.querySelector('#product-form .cart-422-error').remove();
                        }
                        var errorElem = document.createElement('div');
                        errorElem.className = 'cart-422-error py-3';
                        errorElem.textContent = `${res.description}`;
                        this.querySelector('#product-form').appendChild(errorElem);
                    }
                    return;
                }

                // render item in cart
                if(this.cart){
                    this.cart.renderContent(res);
                }else{
                    this.getCartSize();
                }

                // reset
                if(this.querySelectorAll('input[name="quantity"]').length > 0){
                    this.querySelectorAll('input[name="quantity"]').forEach(item => {
                        item.value = '1';
                    })
                }
                if(this.recipientForm){
                    this.recipientForm.reset();
                }
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                this.btnCart.setAttribute('data-disabled', 'false');
            })
        }

        getCartSize(){
            const cartItemsIconUrl = `/?section_id=header-cart-icon`;

            fetch(cartItemsIconUrl)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
          
                return res.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                document.querySelector('custom-header .nav-item .cart-count').innerHTML = resultsMarkup.trim();
                document.querySelector('custom-header .nav-item .cart-count').setAttribute('data-hidden', 'false');
            })
        }

        refresh(){
            this.init();
        }

        isValidDateFormat(dateString) {
            var dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
            return dateFormatRegex.test(dateString);
        }

        isInViewport(el){
            if(!el) return;
            var rect = el.getBoundingClientRect();

            return (
                rect.bottom >= 0 &&
                rect.right >= 0 &&
                rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.left <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        startVideo(elem, mediaType){
            if(mediaType == 'video'){
                elem.play();
            }else if(mediaType == 'external_video'){
                if(elem.closest('.media-wrapper')){
                    const thumbnail = elem.closest('.media-wrapper').querySelector('.thumbnail');
                    if(thumbnail){
                        thumbnail.style.opacity = '0';
                        thumbnail.style.transitionDuration = '0s';
                    }
                }

                var itemSrc = elem.dataset.src;
                if(elem.getAttribute('src') != ''){
                    if(elem.contentWindow){
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                    return; 
                }

                elem.setAttribute('src', itemSrc);
                elem.onload = function() {
                    if (elem.contentWindow) {
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                };
            }
        }

        stopVideo(){
            var externalVideos = this.productMedia.querySelectorAll('iframe');
            externalVideos.forEach(item => {
                item.removeAttribute('data-playing');
                
                // youtube
                if(item.contentWindow)
                    item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');

                // vimeo
                var vimeoUrl = new URL(item.src);
                if (vimeoUrl.hostname.includes('vimeo.com')) {
                    var vimeoData = {
                        method: 'pause'
                    };
                    item.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                    var seekData = {
                        method: 'setCurrentTime',
                        value: 0
                    };
                    item.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
                }
                
            });

            // video
            var embedVideos = this.productMedia.querySelectorAll('video');
            embedVideos.forEach(item => {
                item.removeAttribute('data-active');
                item.pause();
                item.currentTime = 0;
            });

            if(this.productMedia){
                const thumbnail = this.productMedia.querySelector('.thumbnail');
                if(thumbnail){
                    thumbnail.style.opacity = '1';
                    thumbnail.style.transition = 'opacity 0.5s ease-in';
                }
            }
        }
    }

    customElements.define('custom-featured-product', CustomFeaturedProduct);
}